import styled from 'styled-components';

import * as Base from './base';

const CountryCode = styled(Base.CountryCode)`
  margin-block-start: 1px;
`;

const FlagEmoji = styled(Base.FlagEmoji)`
  margin-block-start: 4px;
`;

export * from './base';
export { CountryCode, FlagEmoji };
